<template>
  <div class="container-custom">
    <!-- Breadscrumbs -->
    <Breadscrumbs
      :links="[{ name: 'SupportCategoryCenter', to: { path: '/support-category' } }]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>群組項目</h2>
      <v-spacer></v-spacer>
      <button class="btn btn-primary" @click="toSupportCategoryCreate">
        <v-icon class="mr-2 white--text">add</v-icon>
        <span>新增項目</span>
      </button>
    </div>
    <!-- block -->
    <div class="block mb-5">
      <SupportCategoryTable></SupportCategoryTable>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import SupportCategoryTable from '@/views/G-2__SupportCategory/c/SupportCategoryTable.vue';

export default {
  components: {
    Breadscrumbs,
    SupportCategoryTable,
  },
  created() {
    this.clear();
    this.getSupportCategoryList();
  },
  methods: {
    ...mapActions('supportcategory', {
      getSupportCategoryList: 'find',
      clear: 'clear',
    }),
    toSupportCategoryCreate() {
      this.$router.push('/support-category/create');
    },
  },
};
</script>

<style></style>
